import type React from 'react';
import { usePersonalRedirect } from '@pages/personal/model.ts';
import { EditAndDeleteDropdown } from '@widgets/shared/EditAndDeleteDropdown/index.ts';
import { CoachCardLarge } from '@features/coaches/coachCard';
import { PageBackButton } from '@features/common/PageBackButton';
import { useUser } from '@shared/hooks';
import { ListBody, PageHead } from '@shared/ui';

export const ProfileCoach: React.FC = () => {
  const { user } = useUser();
  // const location = useLocation();
  const { doRedirectOnPrevPage } = usePersonalRedirect();

  // useEffect(() => {
  //   if (location.state?.reload) {
  //     window.location.reload();
  //     window.history.pushState(null, '', '/personal');
  //   }
  // }, []);

  // console.log('user:', user);
  // console.log('contacts:', user?.user?.active_contacts);

  return (
    <>
      <PageHead
        Left={<PageBackButton onClick={() => doRedirectOnPrevPage('/')} />}
        Center={'Профиль'}
        Right={<EditAndDeleteDropdown editText={'Редактировать'} withDeleteButton={false} />}
      />
      <ListBody>
        <CoachCardLarge
          partitions={user?.partitions}
          photo={user?.photo}
          first_name={user?.first_name}
          middle_name={user?.middle_name}
          last_name={user?.last_name}
          tags={user?.tags}
          module={user?.module}
          description={user?.description}
          active_contacts={user?.active_contacts}
          coach_video={user?.coach_video}
        />
      </ListBody>
    </>
  );
};
